import styled from 'styled-components'

const PageContainer = styled.div`
  position: absolute;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`

const ScriptsContainer = styled.div`
  min-width: 452px;
  max-width: 600px;
  width: 60vw;
  min-height: 500px;
  max-height: 80vh;
  background-color: #313a42;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
`

const Header = styled.div`
  width: 100%;
  padding: 16px 24px;
  height: fit-content;
  font-family: "Open Sans";
  font-size: 28px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
`

const Body = styled.div`
  width: 100%;
  flex: 1;
  overflow: auto;
  padding: 16px 24px;
`

const Footer = styled.div`
  width: 100%;
  padding: 4px 24px;
  margin: auto;
  height: fit-content;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  justify-content: center;
`

const NewScriptButton = styled.button`
  font-family: "Open Sans";
  padding: 12px 16px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #46aff2;
  background: none;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: rgba(153, 153, 153, 0.1);
  }
`

const Script = styled.div`
padding: 16px 8px;
border-radius: 6px;

&:hover {
  background-color: rgba(255, 255, 255, 0.05);
}
`

const ScriptTitle = styled.div`
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #fff;
`

export {
  PageContainer,
  ScriptsContainer,
  Header,
  Body,
  Footer,
  NewScriptButton,
  Script,
  ScriptTitle
}
